module.exports = __webpack_public_path__ + "img/7.7c327462.png";